stimulusApp.register(
  "recaptcha",
  class extends Stimulus.Controller {
    static targets = ["error"]

    validate(event) {
      const unchecked = window.grecaptcha?.enterprise.getResponse() === ""

      this.errorTarget.classList.toggle("hidden", !unchecked)
      if (unchecked) event.preventDefault()
    }
  },
)
